import React, { Component } from 'react'
import classNames from '@/helpers/classNames'

import Text from '@/ui/Blocks/Text'
import Image from '@/ui/Blocks/Image'
import ImageText from '@/ui/Blocks/ImageText'
import Infothek from '@/ui/Blocks/Infothek'
import InfothekIcons from '@/ui/Blocks/InfothekIcons'
import Akademie from '@/ui/Blocks/Akademie'
import AkademieCustom from '@/ui/Blocks/AkademieCustom'
import AkademieHeader from '@/ui/Blocks/AkademieHeader'

import ArrowDropDown from '@/icons/ArrowDropDown'
import Remove from '@/icons/RemoveCircle'
import Add from '@/icons/Add'

class Block extends Component {
  state = {
    minimized: false,
  }

  minimizeToggle = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ minimized: !this.state.minimized })
  }

  render() {
    const { theme, item, header, onRemove, onDuplicate, onClick, handle, ...rest } = this.props

    const Component = (
      <Choose>
        <When condition={item.type === 'Card / Text only'}>
          <Text item={item} theme={theme} {...rest} />
        </When>
        <When condition={item.type === 'Card / Text only + CTA'}>
          <Text item={item} theme={theme} cta={true} {...rest} />
        </When>
        <When condition={item.type === 'Card / Image'}>
          <Image item={item} theme={theme} {...rest} />
        </When>
        <When condition={item.type === 'Card / Image + Text'}>
          <ImageText item={item} theme={theme} {...rest} />
        </When>
        <When condition={item.type === 'Card / Image + Text (no CTA)'}>
          <ImageText item={item} theme={theme} cta={false} {...rest} />
        </When>
        <When condition={item.type === 'Card / Akademie'}>
          <Akademie item={item} theme={theme} {...rest} />
        </When>
        <When condition={item.type === 'Card / Akademie custom'}>
          <AkademieCustom item={item} theme={theme} {...rest} />
        </When>
        <When condition={item.type === 'Card / Akademie + header'}>
          <AkademieHeader item={item} theme={theme} {...rest} />
        </When>
        <When condition={item.type === 'Card / Infothek'}>
          <Infothek item={item} theme={theme} {...rest} />
        </When>
        <When condition={item.type === 'Card / Infothek + Icons'}>
          <InfothekIcons item={item} theme={theme} {...rest} />
        </When>
        <Otherwise>
          <div>Wrong type, data error!</div>
        </Otherwise>
      </Choose>
    )
    const displayName =
      this.props.item.type || (Component.type && Component.type.displayName) || 'Error'

    return (
      <div
        onClick={e => onClick(item, e)}
        className={classNames(theme, 'card', 'block-card', {
          'block-minimized': this.state.minimized,
          'block-active': rest.active,
        })}
        data-id={item.id}
      >
        <div className={theme['card-header']} {...handle}>
          <ArrowDropDown size="1em" onClick={this.minimizeToggle} />
          <span>{displayName}</span>
          <div className={theme['float-right']}>
            <Remove size="2.5em" onClick={e => onRemove(e, item.id)} />
            <Add size="2.5em" onClick={e => onDuplicate(item.id)} />
          </div>
        </div>
        <div
          className={classNames(theme, 'card-body', {
            'with-header': header,
            'without-header': !header,
          })}
        >
          <div className={theme['card-content']}>{Component}</div>
        </div>
      </div>
    )
  }
}
export default Block



// WEBPACK FOOTER //
// ./ui/Blocks/Block.js